import { useEffect } from 'react';

/**
 * Land at the top of what was just navigated to (SPEC-007 D-6).
 *
 * Nothing in this app resets scroll on a route change. That is survivable while
 * every navigation is a tap on a link near the top of the screen; it stops being
 * survivable when a SWIPE made two thirds of the way down the page lands the
 * next plant already scrolled two thirds of the way down.
 *
 * The app scrolls in `.app-shell__content`, not the window — `useParallaxScene`
 * already knows this, and reads the same container the same way. The window is
 * the fallback for a shell that has not mounted, so this is safe to call before
 * the tree it scrolls exists.
 *
 * Not smooth: this is not the reader moving through a page, it is a different
 * page arriving, and animating it would mean watching the last plant leave.
 */
export default function useScrollReset(key, { getScrollContainer = defaultScrollContainer } = {}) {
    useEffect(() => {
        const container = getScrollContainer();

        if (!container) {
            return;
        }

        container.scrollTo({ top: 0 });
    // Keyed on what was navigated to, deliberately and only: a caller that
    // passes a fresh getter closure each render must not turn this into a
    // scroll-to-top on every render.
    }, [key]);
}

function defaultScrollContainer() {
    if (typeof document === 'undefined') {
        return null;
    }

    return document.querySelector('.app-shell__content') || window;
}
